import {
  Schedule as CustomDateIcon,
  Today as TodayIcon,
  DateRange as WeekIcon,
} from "@mui/icons-material";
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import React from "react";
import { DateOption } from "./types";
import { format } from "date-fns";
import { FreeSlotChips } from "../free-slots";
import { calculateDueDate } from "./helpers";

interface DateSelectionProps {
  dateOption: DateOption;
  customDate: string | null;
  isUpdating: boolean;
  selectedAction?: string | null;
  onDateOptionChange: (
    event: React.MouseEvent<HTMLElement>,
    newOption: DateOption | null
  ) => void;
  onCustomDateChange: (date: string | null) => void;
  onSlotSelect?: (isoLocalDate: string) => void;
}

const DateSelection: React.FC<DateSelectionProps> = ({
  dateOption,
  customDate,
  isUpdating,
  selectedAction,
  onDateOptionChange,
  onCustomDateChange,
  onSlotSelect,
}) => {
  const handleCustomDateInputChange = (data: Date | null) => {
    onCustomDateChange(data ? format(data, "yyyy-MM-dd'T'HH:mm:ss"): null);
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="body1" gutterBottom>
        När vill du genomföra denna action?
      </Typography>

      <ToggleButtonGroup
        value={dateOption}
        exclusive
        onChange={onDateOptionChange}
        aria-label="när actionen ska utföras"
        fullWidth
        size="small"
        color="primary"
        sx={{ mb: 2 }}
        disabled={isUpdating}
      >
        <ToggleButton value="tomorrow" aria-label="imorgon">
          <TodayIcon sx={{ mr: 1 }} />
          Imorgon
        </ToggleButton>
        <ToggleButton value="week" aria-label="om en vecka">
          <WeekIcon sx={{ mr: 1 }} />
          Om en vecka
        </ToggleButton>
        <ToggleButton value="custom" aria-label="välj datum">
          <CustomDateIcon sx={{ mr: 1 }} />
          Välj datum
        </ToggleButton>
      </ToggleButtonGroup>

      {dateOption === "custom" && (
        <DateTimePicker
          label="Välj datum"
          value={customDate ? new Date(customDate) : null}
          onChange={handleCustomDateInputChange}
          /* disablePast */
          slotProps={{
            textField: {
              fullWidth: true,
              size: "small",
              required: true,
              disabled: isUpdating,
            },
          }}
        />
      )}

      {onSlotSelect && (
        <FreeSlotChips
          date={new Date(calculateDueDate(dateOption, customDate, selectedAction))}
          durationMinutes={60}
          selectedTime={
            dateOption === "custom" && customDate ? new Date(customDate) : null
          }
          disabled={isUpdating}
          onSelectSlot={(slot) =>
            onSlotSelect(format(slot, "yyyy-MM-dd'T'HH:mm:ss"))
          }
        />
      )}
    </Box>
  );
};

export default DateSelection;
